import { gql } from '@apollo/client';

export const CREATE_CHATBOT_SECTION = gql`
  mutation CreateChatbotSection($params: CreateChatbotSection!) {
    createChatbotSection(params: $params) {
      success
      message
      errors
      data {
        id
        code
        name
        description
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const UPDATE_CHATBOT_SECTION = gql`
  mutation UpdateChatbotSection($params: UpdateChatbotSection!) {
    updateChatbotSection(params: $params) {
      success
      message
      errors
      data {
        id
        code
        name
        description
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const DELETE_CHATBOT_SECTION = gql`
  mutation DeleteChatbotSection($params: DeleteChatbotSection!) {
    deleteChatbotSection(params: $params) {
      success
      message
      errors
    }
  }
`;
